import * as Ladda from "ladda"
import init_quiz_mode_selector_modal from "../init/quiz_mode_selector_modal"
import {Controller} from "@hotwired/stimulus"
import {createRoot} from "react-dom/client"
import React from "react"
import ShareQuizModal from "../components/custom_quiz/share_quiz_modal"
import QuizContentInfo from "../components/./embedded_quiz/quiz_content_info"
import modal from "../modal"
import ModalProvider from "../modal_provider"

class SavedCustomQuizController extends Controller {
  static values = {quiz: Object, learnables: Array}
  static targets = ["learnables"]

  connect() {
    this.render_quiz_learnables()
  }

  start(event) {
    const loader = Ladda.create(event.currentTarget).start()
    init_quiz_mode_selector_modal(this.quizValue.slug).finally(loader.stop)
  }

  share() {
    const root = createRoot(document.querySelector("#modal_root"))
    root.render(
      <ModalProvider>
        <ShareQuizModal
          on_close={() => root.unmount()}
          is_open={true}
          quiz={this.quizValue}
        />
      </ModalProvider>
    )
  }

  render_quiz_learnables() {
    if (!this.hasLearnablesTarget) return

    const root = createRoot(this.learnablesTarget)
    root.render(
      <QuizContentInfo learnables={this.learnablesValue} is_truncated={true} />
    )
  }

  open_modal(event) {
    event.preventDefault()
    modal("#cq_cta_modal")

  }
}

export default SavedCustomQuizController
